import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { DateUtils } from 'src/app/_helpers/date-utils';
import { PaginationListResponse } from 'src/app/_models/pagination-list-response';
import { AuthService } from 'src/app/_services/auth.service';
import { GetOfertasNuevasAdmResponse } from '../responses/get-ofertas-nuevas-adm-response';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-adm-ofertas-lista',
  templateUrl: './adm-ofertas-lista.component.html',
  styleUrls: ['./adm-ofertas-lista.component.css']
})
export class AdmOfertasListaComponent implements OnInit{
  public breadcrumb : any;

  currentUser : any

  response : PaginationListResponse<GetOfertasNuevasAdmResponse>; 
  currentPage : number=1;

  constructor(private adminService : AdminService,
              private router : Router,
              private toastr : ToastrService) {
  }
  
  async ngOnInit() {
    await this.getListOfertasNuevas();
    this.breadcrumb = {
      'mainlabel': 'Ofertas Nuevas'
    };
  }

  async getListOfertasNuevas() : Promise<boolean>
  {
    try 
    {
      const result = await firstValueFrom(this.adminService.getOfertasNuevas());
      if(result && result.data && result.totalPages>0 &&result.totalRows>0)
      {
        this.response = result;
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  openDetailOffer(idOferta:number) {
    if(idOferta>0)
    {
      this.router.navigate(['onlyadminaccess/ofertas/detalle'], {
        queryParams: { idOferta: JSON.stringify(idOferta) },
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    else
      this.toastr.error('No se han podido abrir los detalles de la oferta de trabajo. Inténtalo de nuevo.','Error');
  }
  
  convertDate(date:string) : string
  {
    const dateObj = new Date(date);
    return DateUtils.formatDate(dateObj);
  }

  pageChange(page: any) {
    this.adminService
      .getOfertasNuevasByPage((page - 1) * this.response.pageSize)
      .subscribe((response) => {
        this.response = response;
      });
  }
}
